import React from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
import { BookOpen, Wind, Globe, Fuel } from 'lucide-react';
export function FailedSolutions() {
  const failures = [{
    icon: <BookOpen className="w-6 h-6" data-id="element-13" />,
    text: 'Los libros de 300 páginas sobre psicología son imposibles de leer cuando ya estás agotado.'
  }, {
    icon: <Wind className="w-6 h-6" data-id="element-14" />,
    text: '"Respirar profundo" no funciona cuando tu cerebro ya ha entrado en modo de ataque o huida.'
  }, {
    icon: <Globe className="w-6 h-6" data-id="element-15" />,
    text: 'Los consejos genéricos no entienden la presión de criar entre dos culturas y dos idiomas.'
  }, {
    icon: <Fuel className="w-6 h-6" data-id="element-16" />,
    text: 'Intentar "tener más paciencia" es como intentar conducir un coche sin gasolina; no es cuestión de voluntad, es cuestión de combustible.'
  }];
  return <AnimatedSection className="bg-mint-light/30" data-id="element-17">
      <div className="max-w-5xl mx-auto" data-id="element-18">
        <div className="text-center mb-16" data-id="element-19">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4" data-id="element-20">
            Por qué lo que has intentado no funciona
          </h2>
          <p className="text-lg text-charcoal-light" data-id="element-21">
            No es tu culpa. Las herramientas tradicionales no están diseñadas
            para la crisis del momento.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-22">
          {failures.map((item, index) => <div key={index} className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-mint-light/50 flex gap-4 items-start hover:shadow-md transition-shadow duration-300" data-id="element-23">
              <div className="bg-mint/20 text-mint-dark p-3 rounded-xl flex-shrink-0" data-id="element-24">
                {item.icon}
              </div>
              <p className="text-charcoal-light text-lg leading-relaxed pt-1" data-id="element-25">
                {item.text}
              </p>
            </div>)}
        </div>
      </div>
    </AnimatedSection>;
}